import { parseISO } from 'date-fns';
import { Observable } from 'rxjs';
import { ChannelTermAppTile } from './channel-term-app-tile';
import { LanguageTermAppTile } from './language-term-app-tile';
import { AppTileBroadcastMessages } from './message-broadcast-app-tile';

export class AppTile {
  public Id: number;
  public Title: string;
  public Description: string;
  public Url: string;
  public IconClass: string;
  public IconUrl: string;
  public ColorClass: string;
  public ColorHexCode: string;
  public IntegrationEndpointUrl: string;
  public IsPersonal: boolean;
  public ShowAsNewUntilThisDate: Date;
  public Modified: Date;
  public ChannelTermAppTiles: Array<ChannelTermAppTile>;
  public LanguageTermAppTiles: Array<LanguageTermAppTile>;
  public AppTileBroadcastMessages: Array<AppTileBroadcastMessages>;
  public Subscribed: boolean;
  public ChannelSubscribed: boolean;
  public UnreadCounter$: Observable<number>;
  public O365ServiceName: string;
  public UserIsLicensed: boolean;
  public Introduction: string;
  public IntroductionVideo: string;

  /** If the current tile is a smart link > this will have add special behaviour, such as rounding the image corner */
  public IsSmartLink?: boolean;
  public Start?: Date;
  public End?: Date;

  /** Cron expression

    ┌───────────── minute (0 - 59)
    │ ┌───────────── hour (0 - 23)
    │ │ ┌───────────── day of the month (1 - 31)
    │ │ │ ┌───────────── month (1 - 12)
    │ │ │ │ ┌───────────── day of the week (0 - 6) (Sunday to Saturday)
    │ │ │ │ │
    │ │ │ │ │
    * * * * *

    Validation site: https://crontab.guru/
  */
  public CronSchedule?: string;

  public CronTimeZoneId?: string;

  public IsRecurring?: boolean;

  public IsWithinTimeSpan?: boolean;

  /** How long to show the link each time it recurrs.  */
  public RecurringDuration?: {
    Hours: number;
    Minutes: number;
  };

  constructor(opt?: Partial<AppTile>) {
    if (opt) {
      if (opt.ShowAsNewUntilThisDate && typeof opt.ShowAsNewUntilThisDate === 'string') {
        opt.ShowAsNewUntilThisDate = parseISO(opt.ShowAsNewUntilThisDate);
      }

      if (opt.Modified && typeof opt.Modified === 'string') {
        opt.Modified = parseISO(opt.Modified);
      }

      // scheduling for smart links (parse dates)
      if (opt.IsSmartLink) {
        if (opt && opt.Start && typeof opt.Start === 'string') {
          opt.Start = parseISO(opt.Start);
        }

        if (opt.End && typeof opt.End === 'string') {
          opt.End = parseISO(opt.End);
        }
      }

      if (opt.ChannelTermAppTiles && opt.ChannelTermAppTiles.length > 0) {
        opt.ChannelTermAppTiles = opt.ChannelTermAppTiles.map(c => new ChannelTermAppTile({ AppTileId: c.AppTileId, ChannelTermId: c.ChannelTermId }));
      }

      if (opt.LanguageTermAppTiles && opt.LanguageTermAppTiles.length > 0) {
        opt.LanguageTermAppTiles = opt.LanguageTermAppTiles.map(c => new LanguageTermAppTile({ AppTileId: c.AppTileId, LanguageTermId: c.LanguageTermId }));
      }
    }

    Object.assign(this, opt);
  }
}
